import React from 'react';
import {
	styled,
	Form,
	FormItem,
	TextInput,
	Button
} from 'ps-gui';

import {
	getFormItemLabel,
	getPhrase
} from '../../../data/phrases';
import PhoneNumber from '../../../components/phonenumber';
import Message from '../../../blocks/message';
import { getLanguageId } from '../../../data/session';
import Immutable from 'immutable';

const EMPTY_MAP = Immutable.Map({});

export default class LoginForm extends React.PureComponent {

	getBIErrorMessage(errorCode) {
		if (errorCode === 'userExpired') {
			const langId = getLanguageId();
			if (langId === 'EN') {
				return (
					<p>Your Portal account has been terminated. Please contact us at <a href="mailto:portal@intergram.cz">portal@intergram.cz</a>. Thank you.</p>
				);
			} else {
				return (
					<p>Váš přístup do Portálu byl ukončen. Kontaktujte nás na adrese <a href="mailto:portal@intergram.cz">portal@intergram.cz</a>. Děkujeme.</p>
				);
			}
		} else if (errorCode) {
			return (
				<p>
					{getPhrase('unmatchedBankIdLoginMessage.' + errorCode)}<br/>
					<PhoneNumber preset="intergram"/>
				</p>
			);
		} else {
			return (
				<>
					<p>
						{getPhrase('unmatchedBankIdLoginMessage.line1')}
					</p>
					<p>
						{getPhrase('unmatchedBankIdLoginMessage.line2')}
					</p>
					<p>
						{getPhrase('unmatchedBankIdLoginMessage.line3')}
					</p>
				</>
			);
		}
	}

	render() {
		const {data, setProperty, login, showForgottenPasswordForm, bankIdMatcherInfo} = this.props;

		// bankIdMatcherInfo = EMPTY_MAP.set('errorCode', 'userExpired');
		let errorCode = null;
		if (bankIdMatcherInfo) {
			errorCode = bankIdMatcherInfo.get('errorCode');
		}

		return (
			<>
				{
					bankIdMatcherInfo && (
						<Message maxWidth="80vw">
							{
								this.getBIErrorMessage(errorCode)
							}
						</Message>
					)
				}
				<h1>{getPhrase('loginNoun')}</h1>
				<Form vertical onAction={login} key="unamePwd">
					<FormItem label={getFormItemLabel('userName')}>
						<TextInput
							value={data.get('userName') || ''}
							onChange={value => setProperty('userName', value)}
						/>
					</FormItem>
					<FormItem label={getFormItemLabel('password')} error={data.get('loginError')}>
						<TextInput
							value={data.get('password') || ''}
							password
							onChange={value => setProperty('password', value)}
						/>
					</FormItem>
					<Button
						text={getPhrase('login')}
						onAction={login}
					/>
					<Link
						margin="16px 4px"
						onMouseDown={showForgottenPasswordForm}
					>{getPhrase('forgottenPassword')}</Link>
				</Form>
			</>
		);
	}
}

const Link = styled.div`
	color: ${props => props.theme.textColor};
	font-weight: 500;
	cursor: pointer;
	margin: ${props => props.margin};
	&:hover {
		text-decoration: underline;
	}
`;
